import {EvenementCalendrier} from './evenement-calendrier.model';
import {CodeDesignation} from 'sigale-angular';
import {UtilisateurDto} from '../../../dto/utilisateur.dto';
import {TypeEvenementCalendrier} from './type-evenement-calendrier.model';
import {TypeEvenement} from '../../../models/type-evenement.model';

export class Evenement extends EvenementCalendrier {
	dateDemande: Date;
	typeEvenement: CodeDesignation;
	statut: CodeDesignation;
	commentaire?: string;
	dateValidation?: Date;
	validateur?: UtilisateurDto;
	demandeur?: UtilisateurDto;

	constructor(
		id: number,
		date: Date,
		duree: CodeDesignation,
		dateDemande: Date,
		typeEvenement: CodeDesignation,
		statut: CodeDesignation,
		commentaire?: string,
		dateValidation?: Date,
		validateur?: UtilisateurDto,
		demandeur?: UtilisateurDto) {
		super(id, date, duree);
		this.dateDemande = dateDemande;
		this.typeEvenement = typeEvenement;
		this.statut = statut;
		this.commentaire = commentaire;
		this.dateValidation = dateValidation;
		this.validateur = validateur;
		this.demandeur = demandeur;
	}

	getType(): TypeEvenementCalendrier {
		return TypeEvenementCalendrier.EVENEMENT;
	}

	estTeletravail() {
		return this.typeEvenement.code === TypeEvenement.TELETRAVAIL;
	}
}
